var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOntimeLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0771 19.6398C17.15 18.3559 20.1032 14.5486 20.1032 10.0516C20.1032 7.69281 19.2907 5.5238 17.9303 3.80915L8.60604 9.11284V14.3576L4.2694 12.0303V6.52322L14.1894 0.888489C12.9275 0.317732 11.5266 0 10.0516 0C4.50025 0 0 4.50025 0 10.0516C0 15.1121 3.73959 19.2991 8.60604 20V14.3576L13.0771 11.6369V19.6398Z",
    fill: "#F64747"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOntimeLogo);
export default __webpack_public_path__ + "static/media/ontime_logo.6c635d2187ee33c8c66a77732473526f.svg";
export { ForwardRef as ReactComponent };